// @flow

import { useState, useEffect } from "react";

type CallbackType = (...args: any[]) => void;

const useDebounce = (fn: CallbackType, delay: number) => {
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  const debounce = (...args: any[]) => {
    if (timer) {
      clearTimeout(timer);
    }

    const newTimer = setTimeout(() => {
      fn(...args);
    }, delay);

    setTimer(newTimer);
  };

  return debounce;
};

export default useDebounce;
